module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-comparison-3d3302d3ac425d17c19e58dc2f750653.png";